export default __webpack_public_path__ + "static/media/get-approved.ce11dd2b.png";